import React from 'react';
import { STATUS } from '../../../application/common/constants';

import './Loading.css';
interface Spinner {
  status: STATUS;
  displayCondition: boolean;
}

export const Spinner: React.FC<Spinner> = ({
  status,
  displayCondition,
  children,
}) => {
  return (
    <>
      {status === STATUS.LOADING && (
        <div className="d-flex justify-content-center mt-3">
          <div className="loader" />
        </div>
      )}
      {status === STATUS.COMPLETE && displayCondition && children}
    </>
  );
};
